import { h, Component } from 'preact'
import styled from 'styled-components'
import Header_ from '../../components/atoms/header'

const Header = Header_.extend`
  font-size: 30px;
  line-height: 32px;
  margin-bottom: 0;
`

const Party = styled.div`
  text-align: center;
  margin-bottom: 30px;
  font-size: 20px;
`

export default class PoliticianHead extends Component {
  render() {
    const { name, surname, party } = this.props
    return (
      <div>
        <Header>
          {name.trim()} {surname.trim()}
        </Header>
        <Party>{party}</Party>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/politician/politician-head.js